<template>
  <v-container fluid>
    <v-row>
      <NameExperience />
      <Vitals />
      <Stats />
    </v-row>
    <v-row>
      <v-col cols="12" class="py-4">
      </v-col>
      <v-col cols="12" class="py-4">
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import NameExperience from '@/components/NameExperience.vue';
  import Stats from '@/components/Stats.vue';
  import Vitals from '@/components/Vitals.vue';

  export default {
    name: 'CharacterSheet',
    components: {NameExperience, Stats, Vitals},
    computed: {},
  };
</script>
